
































import { Vue, Component, PropSync, Watch, Emit } from "vue-property-decorator";
import { ApkStore } from "./apk.store";
import { ApkDetection, ApkDetectionDeclarationHistory } from "./apk.interface";
import { ApkService } from "./apk.service";
@Component
export default class ApkDetectionDeclarationDialog extends Vue {
  @PropSync("visible", { type: Boolean }) syncVisible!: boolean;
  @ApkStore.State curApkDetection!: ApkDetection;
  @ApkStore.Action loadCurApkDetection: any;

  @Watch("visible") async onApkDetectionChange(val: boolean) {
    if (this.curApkDetection && val) {
      this.loading++;
      this.history = await ApkService.getApkDetectionHistoryDeclaration(
        this.curApkDetection.id
      );
      this.loading--;
    }
  }

  loading = 0;
  submitLoading = false;

  history: ApkDetectionDeclarationHistory[] = [];
  select: any = null;

  async onSubmit() {
    this.submitLoading = true;
    ApkService.loadApkDetectionHistoryDeclaration(
      this.curApkDetection.id,
      this.select
    );
    this.submitLoading = false;
    this.syncVisible = false;
    this.loadCurApkDetection(this.curApkDetection.id);
  }

  onCancel() {
    this.select = null;
    this.syncVisible = false;
  }
}
